<!--
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-10 16:20:37
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-01-13 17:19:40
 * @FilePath: /lobby/src/components/GameTitle.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div class="title_column" v-if="tabItem">
    <div class="left">
      <i :class="`bi ${tabItem.cover}`"></i>
      <h1>{{ tabItem.localName }}</h1>
    </div>
    <div class="right" @click="onClick">
      <a>{{ rightName == '' ? $t('message.viewall') : rightName }} </a>
      <i class="bi bi-chevron-right"></i>
    </div>
  </div>
</template>
<script>
// import { useLobbyStore } from '@/stores/lobby'
// import { mapState } from 'pinia'
export default {
  name: 'DhGameTitle',
  // computed: {
  //   // ...mapState(useLobbyStore, ['currentTabItem'])
  // },
  props: {
    tabItem: {
      type: { cover: String, name: String, localName: String },
      default: {}
    },
    rightName: {
      type: String,
      default: ''
    },
    callback: {
      type: Function,
      default: null
    }
  },
  methods: {
    onClick() {
      // this.$router.replace('allgame')
      this.callback && this.callback()
    }
  }
}
</script>
<style lang="scss" scoped>
.title_column {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: auto;
  width: 100%;
  padding: 0;
  margin: 0.3rem 0;

  .left {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    i {
      font-size: 0.4rem;
      background-image: linear-gradient(to top left, #825c2d, #ffddac 80%);
      background-clip: text;
      color: transparent;
      float: left;
    }

    h1 {
      color: #ffddac;
      font-size: 0.4rem;
      margin: 0 0 0 0.1rem;
      padding: 0;
      display: inline-block;
    }
  }

  .right {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    height: 0.28rem;

    a {
      font-size: 0.28rem;
      color: #ceb45f;
      display: inline-block;
      // float: right;
      margin-top: 0.05rem;
      padding: 0px;
    }

    i {
      float: right;
      font-size: 0.24rem;
      color: #ceb45f;
      line-height: 0.3rem;
      // margin-top: 0.05rem;
    }
  }
}
</style>
